
import { Component, Prop, Vue } from 'vue-property-decorator';
import { relationUserCustomerList } from '@/api/customer';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'CustomeRelatedList',
  components: {

  }
})
export default class extends Vue {
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };

  private listLoading = false;

  private formSearch: any = {
    id: '',
    customer: '',
    type: '',
    mobile: '',
    telephone: ''
  }
  private typeOptions = [{
    value: '1',
    label: '公司'
  }, {
    value: '2',
    label: '个人'
  }]

  private dataTable = []
  private checkAll = false
  private isIndeterminate:any = null
  private selectedbox:any = []
  created() {
    this.getCustomerList();
  }
  handleCurrentChange(size: number) {
    this.pagination.currentPage = size;
    this.getCustomerList();
  }

  handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getCustomerList();
  }
  // 搜索
  private handleSearch() {
    this.pagination.currentPage = 1;
    this.pagination.pageSize = 10;
    this.getCustomerList();
  }

  // 清空
  private handleSearchClear() {
    this.pagination.currentPage = 1;
    this.pagination.pageSize = 10;
    this.formSearch = {
      part: '',
      model: '',
      status: ''
    };
    this.getCustomerList();
  }

  private selectAll:boolean = false;

  private handleSelecAllChange(val:any) {
    if (this.selectAll) {
      this.clearAllRow(val);
    } else {
      this.checkRow(this.dataTable);
    }
    this.selectAll = !this.selectAll;
    this.selectedbox = (this.$refs.tableList as any).selection;
  }

  // 取消选中递归
  private clearAllRow(data:any) {
    Array.from(data).forEach((row:any) => {
      row.isCheck = false;// 给这行数据设置一个选中字段为false
      (this.$refs.tableList as any).toggleRowSelection(row, false);
      if (row.children) this.clearRow(row.children);// 有子集就递归  没子集了就不循环了
    });
  }

  private getLength(m:number, arr:any) {
    m = m + arr.length;
    Array.from(arr).forEach((row:any) => {
      if (row.children) {
        m = this.getLength(m, row.children);
      }
    });
    return m;
  }

  private handleSelectionChange(select:any, row:any) {
    let checkrow = [];
    checkrow.push(row);
    if (row.isCheck) {
      if (select === 1) {
        (this.$refs.tableList as any).toggleRowSelection(row, false);
      }
      this.clearRow(checkrow);
    } else {
      if (select === 1) {
        (this.$refs.tableList as any).toggleRowSelection(row, true);
      }
      this.checkRow(checkrow);
    }
    this.selectedbox = (this.$refs.tableList as any).selection;
  }
  // 取消选中递归
  private clearRow(data:any) {
    Array.from(data).forEach((row:any) => {
      row.isCheck = false;// 给这行数据设置一个选中字段为false
      (this.$refs.tableList as any).toggleRowSelection(row, false);
      // if (row.children) this.clearRow(row.children);// 有子集就递归  没子集了就不循环了
    });
  }
  // 选中递归
  private checkRow(data:any) {
    Array.from(data).forEach((row:any) => {
      row.isCheck = true;// 选中是字段值为true
      (this.$refs.tableList as any).toggleRowSelection(row, true);
      if (row.children) this.checkRow(row.children);
    });
  }
  private load(tree:any, treeNode:any, resolve:any) {
    this.listLoading = true;
    const parentId = tree.customer_company_id;
    this.maps.set(parentId, { tree, treeNode, resolve });
    const params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      customer_company_pid: tree.customer_company_id,
      page: 1,
      size: '999999'
    };
    relationUserCustomerList(params)
      .then((res: any) => {
        const data = res.data;
        if (data !== null) {
          let dataTable:any = data.list;
          tree.children = dataTable;
          dataTable.forEach((item:any) => {
            (item as any).hasChildren = parseInt(item.lower_count) > 0;
          });
          resolve(dataTable);
        } else {
          resolve([]);
        }
        this.listLoading = false;
      })
      .catch((err: any) => {
        this.listLoading = false;
        let msg = err.msg;
        resolve([]);
      });
  }

  // 获取列表
  private getCustomerList() {
    this.listLoading = true;
    const params:any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      company_name: UserModule.getCompanyName ? UserModule.getCompanyName : '',
      page: this.pagination.currentPage,
      size: this.pagination.pageSize
    };
    params.only_id = this.formSearch.id;
    params.customer_name = this.formSearch.customer;
    relationUserCustomerList(params)
      .then((res: any) => {
        const data = res.data;
        if (data !== null) {
          this.pagination.currentPage = parseInt(data.page_current);
          this.pagination.total = parseInt(data.count);
          this.dataTable = data.list;
          this.dataTable.forEach((item:any) => {
            (item as any).hasChildren = parseInt(item.lower_count) > 0;
          });
        } else {
          this.pagination.currentPage = 1;
          this.pagination.total = 0;
          this.dataTable = [];
        }
        this.listLoading = false;
      })
      .catch((err: any) => {
        this.pagination.currentPage = 1;
        this.pagination.total = 0;
        this.dataTable = [];
        this.listLoading = false;
        let msg = err.msg;
      });
  }

  private handleCheckAllChange(val: boolean) {
    let options: any = [];
    if (val) {
      for (let i = 0; i < this.dataTable.length; i++) {
        options.push((this.dataTable[i] as any));
        if ((this.dataTable[i] as any).child) { // 二级
          for (let m = 0; m < (this.dataTable[i] as any).child.length; m++) {
            options.push((this.dataTable[i] as any).child[m]);
            if ((this.dataTable[i] as any).child[m].child) { // 三级
              for (let n = 0; n < (this.dataTable[i] as any).child[m].child.length; n++) {
                options.push((this.dataTable[i] as any).child[m].child[n]);
                if ((this.dataTable[i] as any).child[m].child[n].child) { // 四级
                  for (let v = 0; v < (this.dataTable[i] as any).child[m].child[n].child.length; v++) {
                    options.push((this.dataTable[i] as any).child[m].child[n].child[v]);
                  }
                }
              }
            }
          }
        }
      }
    } else {
      options = [];
    }
    this.selectedbox = options;
    this.isIndeterminate = false;
  }

  private maps:any = new Map()
  // type 1 = add 2 = delete
  private refDataList(pids:any, type:number, hasChildren:boolean) {
    let list = pids.split(',');
    let _ = this;
    if (list) {
      if (hasChildren) {
        _.refData(list[list.length - 1]);
      } else {
        _.refData(list[list.length - 1]);
        _.refData(list[list.length - 2]);
      }
    }
  }

  private refData(pid:any) {
    if (this.maps.get(pid)) {
      this.$set(((this.$refs.tableList) as any).store.states.lazyTreeNodeMap, pid, []);
      const { tree, treeNode, resolve } = this.maps.get(pid);
      this.load(tree, treeNode, resolve);
    }
  }

  private customerOrderHandle(val:any) {
    this.$router.push({
      path: '/CustomeRelated/CustomeRelatedOrder',
      query: { 'CustomeRelatedOrder_jump_CUS': JSON.stringify(val) }
    });
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
